import React from 'react';
import { usePhoneService, PHONE_SERVICES } from '../contexts/PhoneServiceContext';

const PhoneServiceToggle = () => {
  const { 
    activeService, 
    togglePhoneService, 
    isOpenPhoneConfigured,
    isLoading
  } = usePhoneService();

  // If OpenPhone is not configured or we're still loading, disable the toggle
  const isDisabled = isLoading || !isOpenPhoneConfigured;

  // Determine active state for styling
  const isGoogleActive = activeService === PHONE_SERVICES.GOOGLE_VOICE;
  const isOpenPhoneActive = activeService === PHONE_SERVICES.OPENPHONE;

  return (
    <div className="flex items-center space-x-2 py-1">
      <span className="text-xs font-medium text-gray-700">Phone Service:</span>
      <div className="relative inline-flex rounded-md shadow-sm">
        <button
          type="button"
          onClick={() => !isGoogleActive && togglePhoneService()}
          disabled={isDisabled}
          className={`
            relative inline-flex items-center px-3 py-1.5 text-xs font-medium
            transition-colors rounded-l-md 
            ${isGoogleActive 
              ? 'bg-blue-500 text-white z-10 ring-1 ring-blue-500' 
              : 'bg-white text-gray-700 hover:bg-gray-50'}
            ${isDisabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}
          `}
        >
          Google Voice
        </button>
        <button
          type="button"
          onClick={() => !isOpenPhoneActive && togglePhoneService()}
          disabled={isDisabled}
          className={`
            relative inline-flex items-center px-3 py-1.5 text-xs font-medium
            transition-colors rounded-r-md
            ${isOpenPhoneActive 
              ? 'bg-green-500 text-white z-10 ring-1 ring-green-500' 
              : 'bg-white text-gray-700 hover:bg-gray-50'}
            ${isDisabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}
          `}
          title={isDisabled ? 'OpenPhone API not configured' : ''}
        >
          OpenPhone
        </button>
      </div>
      {isLoading && (
        <span className="inline-block ml-2 text-xs text-gray-500">
          <svg className="animate-spin h-3 w-3" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
        </span>
      )}
      {!isLoading && !isOpenPhoneConfigured && (
        <span className="inline-block ml-2 text-xs text-amber-500">
          OpenPhone not configured
        </span>
      )}
    </div>
  );
};

export default PhoneServiceToggle; 